import { Button } from "@library/UI/Button";
import { ReactComponent as BookIcon } from "@assets/images/icons/book.svg";
import { CopytradeHeroSlider } from "./components";

import "./CopytradeHero.sass";

export const CopytradeHero = () => {
  return (
    <div className="copytrade-hero">
      <div className="copytrade-hero__info">
        <div className="copytrade-hero__description">
          <h1 className="copytrade-hero__title">Copytrading</h1>

          <p className="copytrade-hero__text">
            Follow top-perfoming traders and automatically replicate their
            strategies in real-time. Start earning with proven expertise.
          </p>
        </div>

        <div className="copytrade-hero__buttons">
          <Button className="copytrade-hero__button copytrade-hero__button--profile">
            My Deals
          </Button>

          <Button
            className="copytrade-hero__button copytrade-hero__button--deals"
            color="grey"
          >
            My Profile
          </Button>
        </div>

        <div className="copytrade-hero__statistics">
          <div className="copytrade-hero__statistics-item">
            <p className="copytrade-hero__statistics-title">1,500+</p>
            <p className="copytrade-hero__statistics-text">Active Traders</p>
          </div>

          <div className="copytrade-hero__statistics-item">
            <p className="copytrade-hero__statistics-title">$2.4M</p>
            <p className="copytrade-hero__statistics-text">Daily Volume</p>
          </div>

          <div className="copytrade-hero__statistics-item copytrade-hero__statistics-item--last">
            <p className="copytrade-hero__statistics-title">94%</p>
            <p className="copytrade-hero__statistics-text">Success P&L</p>
          </div>
        </div>
      </div>

      <div className="copytrade-hero__guide">
        <a href="" className="copytrade-hero__link">
          <BookIcon />
          Copytrading Guide
        </a>

        <CopytradeHeroSlider />
      </div>
    </div>
  );
};
